import styled from 'styled-components';
import { mqMediumMin, mqLargeMin } from 'styled/tools/media-queries';

const Grid = styled.div<{ noRowGap?: boolean }>`
  display: grid;
  gap: var(--spacing-16);
  grid-template-columns: repeat(var(--space-columns), minmax(0, 1fr));

  @media ${mqMediumMin} {
    gap: var(--spacing-24);
  }

  @media ${mqLargeMin} {
    gap: var(--spacing-32);
  }

  ${({ noRowGap }) =>
    noRowGap &&
    `
      row-gap: 0;
  `}
`;

export { Grid };
